import { ResourceArray } from '@medplum/core'
import { Observation } from '@medplum/fhirtypes'

export function filterObservations(resources: ResourceArray<Observation>) {
    function isPDFObservation(o: Observation) {
        return o.code.text?.includes('PDF Report')
    }

    const filteredResources = resources.filter(resource => {
        if (resource.resourceType === 'Observation') {
            return !isPDFObservation(resource as Observation)
        }
        return true
    })

    return filteredResources
}
